import { defineStore } from 'pinia'
import { reactive } from 'vue'

export type GeracaoArquivoStatus = 'PENDENTE' | 'PROCESSANDO' | 'CONCLUIDO' | 'ERRO'

export interface GeracaoArquivoEstado {
  id: number
  tipo?: string
  titulo?: string | null
  status: GeracaoArquivoStatus
  url: string | null
  erro_mensagem: string | null
}

export const useGeracaoArquivoStore = defineStore('geracaoArquivoStore', () => {
  const geracoes = reactive<Record<number, GeracaoArquivoEstado>>({})

  function setGeracao(dados: GeracaoArquivoEstado) {
    geracoes[dados.id] = { ...geracoes[dados.id], ...dados }
  }

  function getGeracao(id: number): GeracaoArquivoEstado | undefined {
    return geracoes[id]
  }

  return {
    geracoes,
    setGeracao,
    getGeracao,
  }
})
